var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 69,
    viewBox: "0 0 61 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 31.105V9.29031L36.7794 30.0769L0.344588 0V29.7982H8.3857V17.2212L31.3971 35.3846L8.27082 50.7586V37.9556H0V69L31.3971 35.3846L61 60.0496V37.0114H53.6474V44.527L36.7794 30.0769L53.6474 24.3597V31.1051L61 31.105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLogo);
export default __webpack_public_path__ + "static/media/Product-logo.202517b2aff8a9c57690bdf9c072340a.svg";
export { ForwardRef as ReactComponent };